export const SITE_NAME = '爱迪生国际SMS'
export const SITE_NAME_EN = 'Edison International SMS'
export const SITE_NAME_PRIMARY = '爱迪生'
export const SITE_NAME_MIDDLE = '国际'
export const SITE_NAME_SUFFIX = 'SMS'
